export const passPrintTemplate = async (encoder, t, company, accessPass) => {
  encoder
    .initialize()
    .codepage('auto')
    .newline()
    .size(2)
    .align('center')
    .bold(true)
    .line(company.name)
    .bold(false)
    .newline()
    .size(1)
    .line(`${t('labels.no')}: ${accessPass.no}`)
    .newline()
    .line(`${t('labels.organizational_structure')}: ${accessPass.head_of_unit?.name ?? '/'}`)
    .newline()
    .line(`${t('labels.employee')}: ${accessPass.employee ? `${accessPass.employee.first_name} ${accessPass.employee.last_name}` : '/'}`)
    .newline()
    .qrcode(accessPass.no, 2, 8)

  return encoder
}
